import React, { useState, useEffect } from 'react';
import { BringzzAccordion, BringzzButton, BringzzText } from "@bringzz/components";
import { useParams } from 'react-router-dom';
import { useNavigation } from 'context/NavigationContext';
import { useOverlay } from 'context/OverlayContext';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzBasketProduct,
    BringzzProgressBar,
    BringzzBottomDrawer,
    BringzzRadioList,
    BringzzRadio,
    BringzzInput
} from "@bringzz/components";
import { useSocket } from 'context/SocketClusterContext';
import useRequest from 'hooks/useRequest';
import { useOrder } from 'context/OrderContext';
import RocketImage from 'assets/images/Rocket.png'
import BringzzOrderCardSmallAccordion from 'components/BringzzOrderCardSmallAccordion';
import BringzzCustomerCardSmall from 'components/BringzzCustomerCardSmall';
import BringzzShopperCardSmall from 'components/BringzzShopperCardSmall';
import InvoiceStep, { InvoiceView } from 'components/InvoiceStep';
import ImageViewerModal from 'components/ImageViewerModal';
import { pharmacyPickupSegments, pharmacyCollectSegments, pharmacyMailSegments } from 'constants/orderSegments';
import { ORDER_STATUS, DELIVERY_TYPES } from 'utils/constants';

let state = {
    checked: (
        <BringzzIcon
            icon="IconCheck"
            library="Custom"
            className="h-5 w-5 p-1 bg-magic-lilac text-light rounded-full"
            size="12"
        />
    ),
    unChecked: (
        <div></div>
    ),
};

const MatchmakingPharmacyPage = () => {
    const { backPress, navigate } = useNavigation();
    const { step } = useParams();
    const [activeStep, setActiveStep] = useState(step ? parseInt(step, 10) : 0);
    const [selectedTip, setSelectedTip] = useState(null);
    const [cancelOrderDrawer, setCancelOrderDrawer] = useState(false)
    const [selectedReason, setSelectedReason] = useState()
    const { showOverlayContent, hideOverlay } = useOverlay();
    const { sendMessage, onRefetchData } = useSocket();
    const { sendRequest, data, error, loading } = useRequest();
    const { orderDetails, activeStep: contextActiveStep, stopMatchingProcess, proceedToNextStep, refetchOrder, resetOrderContext, prescriptionInfo, pharmacyInvoiceData, fetchPharmacyInvoiceData } = useOrder()
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [modalInvoice, setModalInvoice] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);
    const [modalError, setModalError] = useState(null);
    const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);

    useEffect(() => {
        if (step) {
            setActiveStep(parseInt(step, 10));
        }
    }, [step]);

    const processOrder = async () => {
        console.log("processOrder");
        console.log(orderDetails);

        // TODO: Implement packages logic
        // await sendRequest({
        //     method: 'POST',
        //     url: `/module/order/orderIsReady`,
        //     data: {
        //         "orderUUID": orderDetails.integrationId,
        //     }
        // }).then((response) => {
        //     if (response.status === 'success') {
        //         proceedToNextStep()
        //         setActiveStep(1)
        //     } else {
        //         console.log("orderIsReady error");
        //     }
        // }).catch((error) => {
        //     console.error(error);
        // })
        let hasPrescription = false;
        if (Array.isArray(orderDetails?.prescription)) {
            hasPrescription = orderDetails.prescription.length > 0;
        } else if (orderDetails?.prescription && typeof orderDetails.prescription === 'object') {
            hasPrescription = Object.keys(orderDetails.prescription).length > 0;
        }
        const instructions = hasPrescription
            ? "PACKAGE_ORDER_PROCESSING_STARTED_INSTRUCTIONS"
            : "VERIFY_ORDER_CONTENT";
        const nextStep = hasPrescription
            ? "/prescription"
            : "/prescription/valid";

        navigate('/instruction', {
            state: { instructions, nextStep }
        });
        
    }

    const courierArrived = async () => {
        await sendRequest({
            method: 'POST',
            url: `/module/order/courierHasArrived`,
            data: {
                "orderUUID": orderDetails?.integrationId,
            }
        }).then((response) => {
            if (response.status === 'success') {
                proceedToNextStep()
                navigate('/matchmaking/pharmacy/3');
            } else {
                console.log("courierArrived error");
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    let segments = pharmacyPickupSegments({ navigate, processOrder, loading, orderDetails }); // Default fallback
    if (orderDetails?.type == DELIVERY_TYPES.BRINGZZ_PICKUP) {
        segments = pharmacyPickupSegments({ navigate, processOrder, loading, orderDetails })
    } else if (orderDetails?.type == DELIVERY_TYPES.CLICK_AND_COLLECT) {
        segments = pharmacyCollectSegments({ navigate, processOrder, loading, orderDetails })
    } else if (orderDetails?.type == DELIVERY_TYPES.MAIL_DELIVERY) {
        segments = pharmacyMailSegments({ navigate, processOrder, loading, courierArrived, orderDetails })
    }

    console.log(orderDetails);

    const handleCancelOrderDrawer = async () => {
        setCancelOrderDrawer(!cancelOrderDrawer)
    }

    const handleCancelOrder = async () => {
        await sendRequest({
            method: 'POST',
            url: `/module/order/cancelOrder`,
            data: {
                "orderId": orderDetails?.id
            }
        }).then((response) => {
            if (response.status === 'success') {
                navigate('/matchmaking/pharmacy/cancelled')
                stopMatchingProcess()
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    const handleShowOverlay = () => {
        showOverlayContent(
            <div className='h-full w-full bg-white'>
                <div className='flex justify-between p-4'>
                    <div>
                        <BringzzIcon
                            size='22'
                            icon='IconClose'
                            folder='LineIcons'
                            className='cursor-pointer'
                            onClick={hideOverlay}
                        />
                    </div>
                    <div>
                        <BringzzText tag='h3'>Cancellation fees</BringzzText>
                    </div>
                    <div></div>
                </div>
                <div className='p-4 space-y-2'>
                    <BringzzText tag='h3'>Cancellation fees</BringzzText>
                    <BringzzText tag='h4' className='font-normal'>The cancellation is free with in the first 60 sec, after that we will charge our service fee of 99cents. And depending on the process progress we will charge an additional cancellation fee of 5,99 EUR to compensate ... </BringzzText>
                </div>
            </div>
        );
    };

    useEffect(() => {
        const cleanupRefetchData = onRefetchData((data) => {
            console.log({ data });
            if (data?.notificationType?.includes("ORDER_PROGRESS_")) {
                const stepNumber = data.notificationType.split("_")[2];
                if (stepNumber) {
                    return setActiveStep(stepNumber);
                }
            }
            return;
        });

        refetchOrder()

        return () => {
            if (cleanupRefetchData) {
                cleanupRefetchData();
            }
        };
    }, [onRefetchData])

    // Sync local step with context (covers socket-down polling updates)
    useEffect(() => {
        if (typeof contextActiveStep === 'number') {
            setActiveStep(contextActiveStep);
        }
    }, [contextActiveStep]);

    useEffect(() => {
        if (orderDetails?.id && !pharmacyInvoiceData) {
            fetchPharmacyInvoiceData(orderDetails.id).catch(err => {
                console.error('Failed to fetch invoice data:', err);
            });
        }
        if (pharmacyInvoiceData) {
            setModalInvoice(pharmacyInvoiceData);
        }
    }, [orderDetails?.id, pharmacyInvoiceData, fetchPharmacyInvoiceData])

    const selectTip = amount => {
        setSelectedTip(amount); // Update the selected tip
    };

    useEffect(() => {
        if (!orderDetails) {
            resetOrderContext();
            navigate('/home');
        }
    }, [orderDetails, navigate, resetOrderContext]);

    useEffect(() => {
        const timer = setTimeout(() => {
            // Only redirect if on the last step
            if (
                orderDetails &&
                orderDetails?.deliveryStatus >= ORDER_STATUS.ORDER_CONFIRMED_BY_SHOPPER &&
                activeStep === segments?.length - 1 // Only on last step
            ) {
                navigate('/matchmaking/pharmacy/completed');
            }
        }, 2000);

        return () => clearTimeout(timer);
    }, [orderDetails?.deliveryStatus, navigate, activeStep, segments?.length]);

    const handleShowInvoiceModal = async () => {
        setShowInvoiceModal(true);
        setModalLoading(true);
        setModalError(null);
        
        try {
            const invoice = await fetchPharmacyInvoiceData(orderDetails?.id);
            setModalInvoice(invoice);
        } catch (err) {
            setModalError('Failed to fetch invoice.');
        } finally {
            setModalLoading(false);
        }
    };
    const handleDownloadModalInvoice = async () => {
        if (!modalInvoice) return;
        setModalError(null);
        setModalLoading(true);
        try {
            const response = await sendRequest({
                method: 'POST',
                url: '/module/order/downloadInvoicePdf',
                data: { orderId: orderDetails?.id },
                responseType: 'json',
            });
            if (response.status === 'success' && response.data && response.data.content) {
                const { content, filename } = response.data;
                const base64 = content.split(',')[1];
                const byteCharacters = atob(base64);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename || `invoice_${orderDetails?.id}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            } else {
                setModalError('Failed to download PDF.');
            }
        } catch (err) {
            setModalError('Failed to download PDF.');
        } finally {
            setModalLoading(false);
        }
    };

    if (!orderDetails) {
        return null;
    }

    return (
        <>
        <BringzzPageContainer
            className="bg-white"
            header={{
                title: `Order #${orderDetails?.id || ''}`,
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconClose'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={() => navigate('/')}
                    />
                ),
                right: (
                    <BringzzButton size='sm' className='border border-black'>Help</BringzzButton>
                )
            }}
            authenticated={true}
        >
            <div className='px-6'>
                <div className='py-6'>
                    <BringzzText tag='h1' className='text-center'>{segments?.[activeStep]?.status || 'Processing'}</BringzzText>
                    <BringzzText tag='h3' className='text-center font-normal'>{segments?.[activeStep]?.subStatus || ''}</BringzzText>
                </div>

                <BringzzProgressBar state={Number(activeStep) + 1} mode={"custom"} segments={segments} />

                {orderDetails?.customer && <BringzzCustomerCardSmall customer={orderDetails.customer} />}

                <BringzzOrderCardSmallAccordion
                    totalPrice={orderDetails?.totalPrice || 0}
                    products={orderDetails?.products || []}
                    fees={orderDetails?.fees?.totalFees || 0}
                />

                <div className='flex space-x-4 border-b py-2'>
                    <div>
                        <BringzzIcon
                            folder='LineIcons'
                            icon='IconTicketAlt'
                            size='22'
                            className='p-3 rounded-full' />
                    </div>
                    <div className='flex w-full justify-between'>
                        <div>
                            <BringzzText tag='h3'>Invoice</BringzzText>
                            <BringzzText tag='h4' className={'font-normal'}>
                                invoice {modalInvoice?.invoiceNumber ? `${new Date().getFullYear()}-${modalInvoice.invoiceNumber}` : '-'}
                            </BringzzText>                        
                            </div>
                        <div className='flex items-center space-x-2'>
                            <BringzzIcon
                                folder='LineIcons'
                                icon='IconEye'
                                size='22'
                                className='cursor-pointer'
                                onClick={handleShowInvoiceModal}
                            />
                            <BringzzIcon
                                folder='LineIcons'
                                icon='IconUpload'
                                className={activeStep < 7 ? 'text-black/30' : ''}
                                size='16' />
                        </div>
                    </div>
                </div>

                {/* Prescription Section - Always show but with opacity when no prescription */}
                <div className='flex space-x-4 border-b py-2'>
                    <div>
                        <BringzzIcon
                            folder='LineIcons'
                            icon='IconFile'
                            size='22'
                            className='p-3 rounded-full' />
                    </div>
                    <div className={`flex w-full justify-between ${!((orderDetails?.prescription && (Array.isArray(orderDetails.prescription) ? orderDetails.prescription.length > 0 : Object.keys(orderDetails.prescription).length > 0)) || prescriptionInfo) ? 'opacity-35' : ''}`}>
                        <div>
                            <BringzzText tag='h3'>Prescription</BringzzText>
                            <BringzzText tag='h4' className={"font-normal"}>
                                {orderDetails?.prescription?.prescriptionId || prescriptionInfo?.rezId || 'N/A'}
                            </BringzzText>
                        </div>
                        <div className='flex items-center space-x-2'>
                            <BringzzIcon
                                folder='LineIcons'
                                icon='IconEye'
                                size='22'
                                className={((orderDetails?.prescription && (Array.isArray(orderDetails.prescription) ? orderDetails.prescription.length > 0 : Object.keys(orderDetails.prescription).length > 0)) || prescriptionInfo) ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}
                                onClick={() => ((orderDetails?.prescription && (Array.isArray(orderDetails.prescription) ? orderDetails.prescription.length > 0 : Object.keys(orderDetails.prescription).length > 0)) || prescriptionInfo) && setShowPrescriptionModal(true)} />
                        </div>
                    </div>
                </div>

                {orderDetails?.type == DELIVERY_TYPES.BRINGZZ_PICKUP && orderDetails?.shopper && <BringzzShopperCardSmall shopper={orderDetails.shopper} />}

                {/* <BringzzButton size='md' className='text-midnight-blue bg-magic-lilac mt-4' onClick={handleCancelOrderDrawer}>Add comment</BringzzButton> */}

                <div className='border-b mt-4'></div>

                {/* <BringzzButton size='md' className='border border-red-600 text-red-600 mt-4' onClick={handleCancelOrderDrawer}>Cancel reservation</BringzzButton> */}
            </div>

            {/* <BringzzBottomDrawer
                title='Cancel order'
                isOpen={cancelOrderDrawer}
                close={handleCancelOrderDrawer}
            >
                <div className='px-6 pb-6 space-y-4'>
                    <div>
                        <BringzzText tag='h4' className='font-normal'>Let us know why you are cancelling your order.</BringzzText>
                        <BringzzText tag='h4' className='font-normal'>Keep in mind <span onClick={handleShowOverlay} className='cursor-pointer underline'>cancellation fees</span> can apply.</BringzzText>
                    </div>
                    <div className='space-y-2'>
                        <div className='px-4'>
                            <BringzzRadioList
                                onChange={(newValue) => {
                                    setSelectedReason(newValue)
                                }}
                                state={state}
                                className="rounded-xl w-full text-center space-y-2"

                            >
                                <BringzzRadio value="1"
                                    className="p-2 py-2 hover:bg-slate- border rounded-md border-gray-400 flex"
                                >
                                    <BringzzText tag='h4'>Ordered by mistake</BringzzText>
                                </BringzzRadio>
                                <BringzzRadio value="2"
                                    className="p-2 py-2 hover:bg-slate- border rounded-md border-gray-400 flex"
                                >
                                    <BringzzText tag='h4'>{"Consumer/shopper didn't respond"}</BringzzText>
                                </BringzzRadio>
                            </BringzzRadioList>
                            <div className='mt-2'>
                                <BringzzInput placeholder={'Your custom reason'} className='border' onChange={(e, newIsValid, newValue) => {
                                    setSelectedReason(newValue)
                                }}></BringzzInput>
                            </div>
                        </div>
                        <BringzzButton onClick={handleCancelOrder} size='md' disabled={!selectedReason || loading} className='bg-magic-lilac w-full flex justify-center'>Cancel order</BringzzButton>
                        <BringzzButton onClick={handleCancelOrderDrawer} size='md' className='text-magic-lilac border border-magic-lilac w-full flex justify-center'>Cancel</BringzzButton>
                    </div>
                </div>
            </BringzzBottomDrawer> */}
        </BringzzPageContainer>
        {showInvoiceModal && (
            <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-8 max-w-lg w-full relative">
                    <button className="absolute top-2 right-2 text-2xl" onClick={() => setShowInvoiceModal(false)}>&times;</button>
                    <BringzzText tag="h3" className="mb-4">Invoice Details</BringzzText>
                    {modalLoading && <BringzzText>Loading...</BringzzText>}
                    {modalError && <BringzzText className="text-red-600">{modalError}</BringzzText>}
                    {modalInvoice && <InvoiceView invoice={modalInvoice} onDownload={handleDownloadModalInvoice} showDownload={true}/>}
                </div>
            </div>
        )}

        {/* Prescription Image Viewer Modal */}
        <ImageViewerModal
            isOpen={showPrescriptionModal}
            onClose={() => setShowPrescriptionModal(false)}
            imageUrl={orderDetails?.prescription?.photo || prescriptionInfo?.prescriptionImageUrl || prescriptionInfo?.photo || null}
            title="Prescription"
        />
        </>
    );
};

export default MatchmakingPharmacyPage;